<template>
    <v-layout column>
        <v-layout
            v-if="infoLoading"
            align-center
            justify-center
        >
            <v-progress-circular
                :size="60"
                :width="6"
                indeterminate
                class="my-3"
            />
        </v-layout>
        <v-layout column v-else>
            <v-layout justify-space-between align-center>
                <v-toolbar class="text-h5">
                    <v-icon class="mr-3">domain</v-icon>
                    <v-flex>Select Unit</v-flex>
                </v-toolbar>
            </v-layout>
            <v-layout align-center class="my-3">
                <v-layout column class="mx-4 mt-1">
                    <v-flex v-if="unitFeatures" class="text-h6 mb-3">
                        Lead unit size:
                        <span v-if="parseFloat(unitFeatures.width)">
                            '{{ parseFloat(unitFeatures.width) }} x '{{ parseFloat(unitFeatures.length) }}
                        </span>
                        <span v-else>'{{ parseFloat(unitFeatures.length )}}</span>
                    </v-flex>
                    <v-flex class="text-h6">Reservation unit size:
                        <span v-if="convertedReservation">
                            '{{ parseFloat(convertedReservation.width) }} x '{{ parseFloat(convertedReservation.length) }}
                        </span>
                        <span v-else class="font-italic">Select a unit...</span>
                    </v-flex>
                </v-layout>
                <v-autocomplete
                    class="mb-3 mx-4"
                    id="convert-feature-filter"
                    align-with-title
                    :items="availableFeatures"
                    v-model="selectedFeature"
                    label="Filter by available features..."
                    :hint="!selectedFeature ? 'Enter or select a feature' : 'Click X to reset the list'"
                    persistent-hint
                    clearable
                    style="max-width: 25%"
                >
                    <template slot="item" slot-scope="data">
                        <v-list-item-content>
                            {{ data.item }}
                        </v-list-item-content>
                    </template>
                </v-autocomplete>
            </v-layout>
            <v-data-table
                :headers="headers"
                :loading="loading"
                :items="filteredUnits"
                :options.sync="pagination"
                no-data-text="There are no units to display"
            >
                <template slot="item" slot-scope="props">
                    <tr>
                    <td class="py-2">
                        <div class="text-body-2 font-weight-bold">
                            <span v-if="props.item.width">
                                {{ props.item.width }}' x {{ props.item.length }}' - {{ props.item.type_name }}
                            </span>
                            <span v-else>{{ props.item.length }}' - {{ props.item.type_name }}</span>
                        </div>
                        <span class="text-caption" v-for="(feature, i) of props.item.features" :key="feature.i">
                            <span v-if="props.item.features.length && i < (props.item.features.length - 1)">{{ feature }},&nbsp;</span>
                            <span v-else-if="!props.item.features.length && i < Object.keys(props.item.features).length">{{ feature }},&nbsp;</span>
                            <span v-else>{{ feature }}</span>
                        </span>
                    </td>
                    <td class="py-1">
                        <span v-if="props.item.width">{{ props.item.area }} sq. ft.</span>
                        <span v-else>N/A</span>
                    </td>
                    <td class="py-1">{{ props.item.promotion_text }}</td>
                    <td class="py-1">${{ props.item.rate.toFixed(2) }}</td>
                    <td class="py-1">{{ props.item.product_type }}</td>
                    <td class="py-1">{{ props.item.total_vacant }}</td>
                    <td class="py-1">
                        <v-layout column>
                            <v-btn
                                data-testid="convert-select-btn"
                                class="convert-select-btn"
                                color="primary"
                                :outlined="unitSelected(props.item.unit_id_first_available)"
                                @click.stop="setUnit(props.item)"
                            >
                                <span v-if="unitSelected(props.item.unit_id_first_available)" class="primary--text">
                                    Selected
                                    <v-icon small>check</v-icon>
                                </span>
                                <span v-else>
                                    Select
                                </span>
                            </v-btn>
                        </v-layout>
                    </td>
                    </tr>
                </template>
            </v-data-table>
        </v-layout>
        <v-layout>
            <v-btn
                data-testid="convert-options-return-btn"
                class="convert-options-return-btn mt-2"
                @click="toOptions"
            >
                <v-icon class="mr-3">shopping_cart</v-icon>
                Return to Reservation Options
            </v-btn>
        </v-layout>
    </v-layout>
</template>

<script>
import { unitSelectHeaders } from "@/helpers/convert-lead/unit-select-data-table-headers";

/* eslint-disable eqeqeq */
export default {
  props: ["lead", "unitFeatures", "availableUnits", "infoLoading", "convertedReservation"],

  data() {
    return {
      loading: false,
      selectedFeature: "",
      selectedUnit: "",
      pagination: {
        sortBy: ["area"],
        sortDesc: [true]
      },
      headers: unitSelectHeaders
    };
  },

  methods: {
    setUnit(unit) {
      this.$emit("setUnit", unit);
    },

    toOptions() {
      this.$emit("toOptions");
    },

    unitSelected(unitId) {
      return unitId === this.convertedReservation.unit_id_first_available;
    }
  },

  computed: {
    filteredUnits() {
      return this.selectedFeature ? this.availableUnits.filter(unit => {
        for (let detail in unit) {
          if (detail === "features" && Object.values(unit[detail]).includes(this.selectedFeature)) {
            return unit[detail];
          }
        }
      }) : this.availableUnits;
    },

    availableFeatures() {
      let arr = [];
      this.availableUnits.map(unit => {
        for (let detail in unit) {
          if (detail === "features") {
            Object.values(unit[detail]).forEach(value => arr.push(value));
          }
        }
      });
      return [...new Set(arr)];
    }
  }
};
</script>
